import React, { memo } from 'react'
import PropTypes from 'prop-types'
import SignUpForm from '@v4/components/common/Form/SignUpForm'
import PageMetaData from '@v4/utils/data/PageMetaData'
import PopupModal from '../../components/PopupModal'
import { useSingUpLanding } from './SingUpLanding.hooks'

const SingUpLanding = props => {
	const [
		{
			open,
			buttonText,
			title,
			placeholderColor,
			titleEditable,
			buttonTextEditable,
			buttonTextConfig,
			titleConfig,
			buttonTextKey,
			titleKey,
		},
		{ handleButtonClick, handleClose, handleTitleClick, handleTitleChange, handleButtonTextChange },
	] = useSingUpLanding(props)

	return (
		<PopupModal className="popup-modal-landing" open={open} onClose={handleClose}>
			<SignUpForm
				className="sign-up-form-landing"
				placeholderColor={placeholderColor}
				buttonText={buttonText}
				title={title}
				titleConfig={titleConfig}
				usePaperColors
				onTitleClick={handleTitleClick}
				onButtonClick={handleButtonClick}
				titleEditable={titleEditable}
				onTitleChange={handleTitleChange}
				buttonTextEditable={buttonTextEditable}
				buttonTextConfig={buttonTextConfig}
				onButtonTextChange={handleButtonTextChange}
				titleKey={titleKey}
				buttonTextKey={buttonTextKey}
			/>
		</PopupModal>
	)
}

SingUpLanding.propTypes = {
	metaData: PropTypes.shape({
		placeholderColor: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		title: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(SingUpLanding)
